import React from 'react';
import styled, { keyframes } from 'styled-components';

import { Colors } from 'mineralsoft/components/common/constants';

const loadAnimation = keyframes`
  0% { background: ${Colors.silver}; }
  25% { background: ${Colors.slate}; }
  50% { background: ${Colors.silver}; }
`;

const Animated = styled.div`
  flex-direction: row;
  display: flex;
`;

interface CircleProps {
  size: string;
  animationDelay: string;
}

const Circle = styled.div<CircleProps>`
  ${({ size }) => `
    width: ${size};
    height: ${size};
    margin: calc(${size} / 3);
  `}
  border-radius: 50%;
  background: ${Colors.softFog};
  animation: ${loadAnimation} 2s ease both infinite;
  animation-delay: ${({ animationDelay }) => animationDelay};
`;

interface SubtleIndicatorProps {
  size?: string;
}

const SubtleIndicator: React.FC<SubtleIndicatorProps> = ({ size = '3px' }) => (
  <Animated>
    <Circle size={size} animationDelay="0s" />
    <Circle size={size} animationDelay="0.5s" />
    <Circle size={size} animationDelay="0.75s" />
  </Animated>
);

export default SubtleIndicator;
